import type { SiteName } from '@/scopes/common/domain/types'
import { NO_UPCOMING_BOOKING_IMAGE_SRC } from '@/scopes/account/common/constants'

const NO_UPCOMING_BOOKING_IMAGE_URLS: Partial<Record<SiteName, string>> = {
  sunwebnl: `https://www.sunweb.nl${NO_UPCOMING_BOOKING_IMAGE_SRC.sun}`,
  sunwebbenl: `https://www.sunweb.be/nl${NO_UPCOMING_BOOKING_IMAGE_SRC.sun}`,
  sunwebbefr: `https://www.sunweb.be/fr${NO_UPCOMING_BOOKING_IMAGE_SRC.sun}`,
  sunwebde: `https://www.sunweb.de${NO_UPCOMING_BOOKING_IMAGE_SRC.sun}`,
  sunwebse: `https://www.sunweb.se${NO_UPCOMING_BOOKING_IMAGE_SRC.ski}`,
  sunwebuk: `https://www.sunweb.co.uk${NO_UPCOMING_BOOKING_IMAGE_SRC.ski}`,
  sunwebfr: `https://www.sunweb.fr${NO_UPCOMING_BOOKING_IMAGE_SRC.sun}`,
  sunwebdk: `https://www.sunweb.dk${NO_UPCOMING_BOOKING_IMAGE_SRC.sun}`,
  elizanl: `https://www.elizawashere.nl${NO_UPCOMING_BOOKING_IMAGE_SRC.eliza}`,
  elizabe: `https://www.elizawashere.be${NO_UPCOMING_BOOKING_IMAGE_SRC.eliza}`,
}

export function getNoUpcomingBookingImageUrl(siteName: SiteName): string {
  return NO_UPCOMING_BOOKING_IMAGE_URLS[siteName] ?? ''
}
